import { WlaCategory } from 'components/types/wla/wlaCategory/types';

const CleanData = (data: any): any => {
  const cleanedData: any = {};

  for (const key in data) {
    const value = data[key as keyof any];

    if (value !== '' && value !== null && value !== undefined) {
      cleanedData[key as keyof any] = value;
    }
  }

  return cleanedData;
};

export default CleanData;
